import { ChangeEvent } from 'react'
import { Option } from '../SelectSearch'

export type TInputType =
  | 'date'
  | 'decimal'
  | 'number'
  | 'multiselect'
  | 'rich_text'
  | 'select'
  | 'text'
  | 'year_month'

export const createChangeEvent = (value: string) => {
  const inputElement: HTMLInputElement = document.createElement('input')

  // synthetic event in order to manually set value
  const event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement> = {
    target: {
      ...inputElement,
      value: value
    } as EventTarget & (HTMLInputElement | HTMLTextAreaElement),
    currentTarget: inputElement,
    bubbles: true,
    cancelable: true,
    defaultPrevented: false,
    eventPhase: 3,
    isTrusted: false,
    nativeEvent: {} as Event,
    preventDefault: () => {},
    isDefaultPrevented: () => false,
    stopPropagation: () => {},
    isPropagationStopped: () => false,
    persist: () => {},
    timeStamp: Date.now(),
    type: 'change'
  }

  return event
}

export const isResetable = (type: TInputType, options?: Option[]) => {
  // checks if the returned value can be set to ''
  if (type === 'select' && options) {
    return options?.some((option) => option.id === '')
  }

  // Both clear themselves — an empty multi-select is [], an empty document
  // is null — so a Rensa link would sit there doing nothing.
  if (type === 'multiselect' || type === 'rich_text') {
    return false
  }

  return true
}
